/**
 * Sub-channel a prospect is locked into at their first touch in Staff, set once on the Amplitude
 * user by every Staff Funnel event (staff-fe prospect-funnel.js and the pre-login Bridge Link
 * Opened endpoint in external-api-be). Derived from the offer being touched: isAgentSold is the
 * offer's channel (from its affinity, not from who is logged in) and originallyFrom is fixed when
 * the offer lineage is created.
 */
export const PROSPECT_CHANNELS = {
  AGENCY_COMP_RATER: 'agency-comp-rater',
  AGENCY_STAFF: 'agency-staff',
  AGENCY_OTHER: 'agency-other',
  INTERNAL_SALES: 'internal-sales'
} as const;

export type ProspectChannel = (typeof PROSPECT_CHANNELS)[keyof typeof PROSPECT_CHANNELS];

export const deriveProspectChannel = (
  offer: { quote?: { isAgentSold?: unknown; originallyFrom?: string | null } | null } | null | undefined
): ProspectChannel | undefined => {
  const isAgentSold = offer?.quote?.isAgentSold;
  if (typeof isAgentSold !== 'boolean') {
    return undefined;
  }
  if (!isAgentSold) {
    return PROSPECT_CHANNELS.INTERNAL_SALES;
  }
  switch (offer?.quote?.originallyFrom) {
    case 'api':
      return PROSPECT_CHANNELS.AGENCY_COMP_RATER;
    case 'staff':
      return PROSPECT_CHANNELS.AGENCY_STAFF;
    default:
      return PROSPECT_CHANNELS.AGENCY_OTHER;
  }
};
